<template>
	<div id="novel_chapter">
		<div class="novel_chapter">
			<div class="novel_list">
				<div class="novel_list1 cursor_1" @click="toNovellist">
					<img src="../assets/image/icon_right.png" alt="">
					{{ novelInfo.name }}
				</div>
				<div class="flex-row">
					<div v-if="mixinNInfo && mixinUserInfo && mixinNInfo.recall && zsVip()" style="padding: 0 10px;">
						<el-switch v-model="recall" @change="recallChange" :width="140" class="main-el-switch"
							　　active-text="已开启长记忆" 　　inactive-text="已关闭长记忆" />
					</div>
					<el-button type="primary" v-if="chapterList.length > 0 && mixinNInfo && !mixinNInfo.status"
						@click="updateText" class="novel_list2">
						<span>上传正文</span>
					</el-button>
					<el-button type="primary" v-if="chapterList.length > 0" @click="nextStep" class="novel_list2">
						<span class="el-icon-plus" style="font-weight: bold;"></span>
						<span>续写章节</span>
					</el-button>
				</div>

			</div>
			<div class="novel_chapter1">
				<div class="novel_chapter1_1">
					<!-- 表格标题 -->
					<div class="novel_chapter1_2">
						<div class="novel_chapter1_3" v-for="(item, i) in chapterTitle" :key="i">
							{{ item }}
						</div>
					</div>
					<!-- 章节 -->
					<div class="novel_chapter1_2" v-for="(item, i) in chapterList" :key="i"
						@click.self="lookChapter(i, item)">
						<div class="novel_chapter1_4" style="width: 5%;">{{ item.number }}</div>
						<div class="novel_chapter1_4 novel_chapter1_5" style="width: 30%;text-align: left;">
							<span class="t-p-l-20">{{ item.name }}</span>
							<div class="recall-yjy" v-if="item.recall">
								<span>已记忆</span>
							</div>
						</div>
						<div class="novel_chapter1_4" style="width: 10%;">{{ item.textNumber }}</div>
						<div class="novel_chapter1_4 novel_chapter1_7" style="width: 20%;">{{ item.createTime }}</div>
						<div class="novel_chapter1_4"
							style="width: 10%;display: flex;align-items: center;justify-content: center;">
							<div
								:class="item.statusInstructions == '未完成' ?
									'novel_chapter1_8 novel_chapter1_9' : item.statusInstructions == '创作中' ? 'novel_chapter1_30' : 'novel_chapter1_8'">
							</div>
							{{ item.statusInstructions }}
						</div>
						<div class="novel_chapter1_4"
							style="flex: 1;display: flex;align-items: center;justify-content: center;">
							<div v-if="item.statusInstructions == '已完成' || item.statusInstructions == '创作中'"
								class="novel_chapter1_12 cursor_1" @click="editchapter(i, 1)">编辑章节</div>
							<div v-if="item.statusInstructions == '已完成' || item.statusInstructions == '创作中'"
								class="novel_chapter1_12 cursor_1" @click="copy(item.textId)">复制正文</div>
							<div v-if="item.statusInstructions == '未完成' && item.current" class="novel_chapter1_11">
								<div class="novel_chapter1_12 cursor_1" @click="editchapter(i, 2)">手写正文</div>
								<div class="novel_chapter1_12 cursor_1" @click="editchapter(i, 3)">AI写正文</div>
							</div>
							<div class="novel_chapter1_11">
								<div class="novel_chapter1_12 cursor_1" @click="delChapters(item, i)">删除</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<bottomPage v-show="total" :total="total" @currentNUm="currentNUm" ref="bottompage"></bottomPage>
		<!-- <outlineContinuous :novelId="novelInfo.id" ref="outlineContinuous" @getContinued="getContinued">
		</outlineContinuous> -->

	</div>
</template>

<script>
import { copy } from '@/utils/utils'
import bottomPage from '../components/bottom_page.vue' //底部分页
import outlineContinuous from '@/components/outline_continuous.vue'
import api from '@/api/api';
import { EncryptionUtil } from '@/utils/encrypt'
export default {
	components: {
		bottomPage, outlineContinuous
	},
	data() {
		return {
			chapterTitle: ['章节', '章节名称', '字数', '发布时间', '状态', '操作'],
			chapterList: [],
			total: null, //总条数,
			pageNum: 1,
			pageSize:10,
			novelInfo: {}, //小说信息
			newNumber: null, //最新章节
			isInit: false,//默认false 是初始化，true，不是初始化
			recall: true,//已经开启
		}
	},
	created() {
		this.getUserLoginState(false)
	},
	methods: {
		toNovellist() {
			this.$emit('toNovellist')
		},
		async getChapterList(noveldata) {
			debugger
			console.log(noveldata)
			if (!noveldata) return
			this.mixinNovelInfo(noveldata.id)
			this.novelInfo = noveldata;
			let key = this.getChapterSearchKey(this.nChapterSearchKey, this.novelInfo.id)
			const novelChapterSearch = JSON.parse(localStorage.getItem(key)) || {}
			console.log(novelChapterSearch)
			this.pageNum = novelChapterSearch?.pageNum || 1
			await this.getNewChapter(noveldata.id);
			try {
				const result = await api.getChapterList1(noveldata.id, 1,this.pageSize);
				//先去请求总数，去计算是在当前页还是上一页
				let total = result.total
				if(!total){
					this.toNovellist()
					return
				}
				const maxPage = Math.ceil(total / this.pageSize)
				this.pageNum = Math.min(this.pageNum, maxPage ? maxPage : 1)
				localStorage.setItem(key, JSON.stringify({ pageNum:this.pageNum,pageSize:this.pageSize }))

				if (this.$refs.bottompage) {
					this.$refs.bottompage.page(this.pageNum)
				}

				const res = await api.getChapterList1(noveldata.id, this.pageNum,this.pageSize);
				if (res.code === 200) {
					let firstStatus = false;
					this.total = res.total;
					this.chapterList = res.rows.map(item => {
						if (this.newNumber == item.number && !firstStatus) {
							firstStatus = true;
							return { ...item, current: true };
						}
						return { ...item, current: false };
					});
					this.isInit = this.chapterList.some(item => item.statusInstructions === '已完成' || item.statusInstructions == '创作中')
				}
			} catch (error) {
				console.error('获取章节列表出错:', error);
			}
		},
		async getNewChapter(id) {
			try {
				const res = await api.getNewChapter(id);
				if (res.code === 200) {
					if (res.data === '章节都已完成') {
						this.newNumber = '章节都已完成';
					} else {
						this.newNumber = res.data.number;
					}
				}
			} catch (error) {
				console.error('获取最新章节出错:', error);
			}
		},
		// 编辑 1编辑 2手写 3Ai生成
		editchapter(i, edit) {
			let prevTextId = ''
			if (i > 0 && this.chapterList[i].number > 1) {
				prevTextId = this.chapterList[i - 1].textId
			}
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editText: edit,
				chapter: this.chapterList[i].number,
				chapterId: this.chapterList[i].id,
				chapterName: this.chapterList[i].name,
				prevTextId: prevTextId,
				textId: this.chapterList[i].textId,
				pageNum: this.pageNum,
				pageSize: 10,
				asc: 'asc'
			};
			console.log('章节id=', this.chapterList[i].textId)
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/editor' });
		},
		delChapters(item, index) {
			let text = ''
			if (index == this.total - 1) {
				text = `是否需要删除从第${index + 1}章，删除后无法恢复，请慎重操作`
			} else {
				text = `是否需要删除从第${index + 1}章到后面所有的章节，删除后对应的章节和正文都会删除，且无法恢复，请慎重操作`
			}
			this.$confirm(text, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {

				//如果当前有id说明是已经存在的，如果没有id说明是刚ai生成的
				// console.log('data=', data)
				api.delNovelOutline({ id: item.id }).then(res => {
					if (res.code === 200) {
						this.$message.success('删除成功')
						this.getChapterList(this.novelInfo)
						// this.toNovellist()
					}
				})
			})
		},
		//续写大纲
		nextStep() {
			// this.$refs.outlineContinuous.openPopup();
			this.getContinued()
		},
		//编辑
		lookChapter(i, item) {
			if (item.statusInstructions == '已完成' || item.statusInstructions == '创作中') {
				this.editchapter(i, 1)
			}
		},
		//选择条件
		getContinued() {
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editType: 3,
				isAiCreate: true,
				editText: 1,
			};
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/editor' });
		},
		//复制
		copy(textId) {
			api.getNovelContent(textId).then(async (res) => {
				if (res.code == 200) {
					let tc = res.data.textTitle + '\n' + this.stripHtmlTags(res.data.textContent)
					const success = await copy(this.stripHtmlTags(tc));
					if (success) {
						this.$message.success('复制成功');
					} else {
						this.$message.error('复制失败');
					}
				}
			})
		},
		currentNUm(pageNum) {
			this.pageNum = pageNum
			//分页记录缓存
			let key = this.getChapterSearchKey(this.nChapterSearchKey, this.novelInfo.id)
			localStorage.setItem(key, JSON.stringify({ pageNum,pageSize:this.pageSize }))
			this.getChapterList(this.novelInfo)
		},
		//上传正文
		updateText() {
			if (this.novelInfo && !this.novelInfo.id) return
			this.$router.push({
				path: '/chapterUpdate', query: {
					novelId: this.novelInfo.id,
					newNumber:this.newNumber,
					pageNum: this.pageNum,
					pageSize: 10,
					novelInfo: EncryptionUtil.encrypt(this.novelInfo)
				}
			})
		},
		//关闭长记忆
		recallChange(e) {
			this.recall = true
			this.$confirm('该作品的长记忆功能一旦关闭将永久失效，且无法再次开启，是否确认关闭?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				api.recallStop({ novelId: this.novelInfo.id, type: 'novle' }).then(res => {
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: '已关闭长记忆功能!'
						});
						this.recall = false
						this.mixinNovelInfo(this.novelInfo.id)
					} else {
						this.recall = true
						this.$message.warning(res.msg)
					}
				}).catch(_ => {
					this.recall = true
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消关闭长记忆功能'
				});
				this.recall = true
			});
		}
	}
}
</script>

<style scoped>
#novel_chapter {
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.novel_list {
	display: flex;
	align-items: center;
	height: 77px;
	justify-content: space-between;
	border-bottom: 1px solid #e6ebf0;
	padding: 0 25px;
}

.novel_list1 {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	font-weight: 700;
	font-size: 19px;
	color: #111;
}

.novel_chapter {
	background-color: #FFFFFF;
	height: calc(100% - 90px);
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	border-radius: 8px;
	overflow: hidden;
}

.novel_chapter1 {
	height: calc(100% - 78px);
	overflow-y: auto;
	-ms-overflow-style: none;
	scrollbar-width: none;
	padding: 25px;
}

.novel_chapter1_1 {
	height: 100%;

}

.novel_chapter1_2 {
	display: flex;
	width: 100%;
}

.novel_chapter1_3 {
	font-size: 15px;
	color: #333333;
	height: 50px;
	line-height: 50px;
	background-color: #F5F7FA;
	border-right: 1px solid #E6EBF0;
	border-bottom: 1px solid #E6EBF0;
}

.novel_chapter1_3:first-child {
	width: 5%;
	text-align: center;
}

.novel_chapter1_3:nth-child(2) {
	width: 30%;
	text-align: center;
}

.novel_chapter1_3:nth-child(3) {
	width: 10%;
	text-align: center;
}

.novel_chapter1_3:nth-child(4) {
	width: 20%;
	text-align: center;
}

.novel_chapter1_3:nth-child(5) {
	width: 10%;
	text-align: center;
}

.novel_chapter1_3:nth-child(6) {
	flex: 1;
	text-align: center;
	border-right: none;
}

.novel_chapter1_4 {
	height: 50px;
	line-height: 50px;
	border-bottom: 1px solid #E6EBF0;
	font-size: 15px;
	color: #111111;
	text-align: center;
	position: relative;
}

.novel_chapter1_5 {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.novel_chapter1_8 {
	width: 10px;
	height: 10px;
	background: #01CC7A;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_30 {
	width: 10px;
	height: 10px;
	background: #548AFF;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_9 {
	background: #FFB400;
}

.novel_chapter1_11 {
	display: flex;
}

.novel_chapter1_12 {
	color: #548AFF;
	margin-right: 8px;
}

.novel_chapter2 {
	width: 104px;
	height: 38px;
	line-height: 38px;
	font-size: 16px;
	color: #FFFFFF;
	background: var(--tech-primary);
	background-repeat: no-repeat;
	background-size: 20px 20px;
	border-radius: 4px;
	text-align: center;
	cursor: pointer;
}

.novel_chapter3 {
	width: 104px;
	height: 38px;
	line-height: 38px;
	font-size: 16px;
	color: #FFFFFF;
	background: var(--tech-primary);
	border-radius: 4px;
	cursor: pointer;
}

/* .novel_chapter3:hover {
	color: var(--tech-primary);
	background: var(--tech-btn-Lightblue);
	background-image: url('../assets/image/icon_list1.png');
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: 5px center;
} */
</style>
<style lang="scss" scoped>
::v-deep .clearPadding .vxe-cell {
	padding: 0;
}

::v-deep .clearPaddingLeft .vxe-cell {
	padding-left: 0px;
}

::v-deep {
	.main-el-switch {
		position: relative;

		.el-switch__core {
			height: 40px;
			border-radius: 20px;

			&:after {
				left: 3px;
				top: 3px;
				height: 32px;
				width: 32px;
			}
		}

		&.el-switch {
			height: 40px;
			line-height: 40px;

			&.is-checked {
				.el-switch__core {
					&:after {
						margin-left: -35px;
						left: 100%;
					}
				}
			}
		}

		&.is-checked {
			.el-switch__label--left {
				opacity: 0;
			}

			.el-switch__label--right {
				opacity: 1;
			}
		}

		.el-switch__label {
			position: absolute;
			top: 0;
		}

		.el-switch__label--left {
			right: 0;
			color: #999;
			z-index: 1;
			margin-right: 8px;
		}

		.el-switch__label--right {
			left: 0;
			color: #fff;
			opacity: 0;
			margin-left: 8px;
		}
	}
}

.recall-yjy {
	position: absolute;
	left: 0;
	top: -8px;
	transform: rotate(-20deg);

	span {
		padding: 0 3px;
		color: #f56c6c;
		background-color: rgba(254, 240, 240, 0.2);
		border-radius: 6px;
		border: 1px solid #fde2e2;
		font-size: 14px;
		line-height: 1;
	}
}
</style>